import React from 'react';

import { TailwindWrapper } from '@utils/TailwindWrapper';

export const withTailwindWrapper = <T extends object>(
  Component: React.ComponentType<T>
): React.ComponentType<T & { twIsolated?: boolean }> => {
  const WrappedComponent: React.FC<T & { twIsolated?: boolean }> = (props) => {
    const { twIsolated, ...restProps } = props;

    if (twIsolated) {
      return (
        <TailwindWrapper>
          <Component {...(restProps as T)} />
        </TailwindWrapper>
      );
    }
    return <Component {...(restProps as T)} />;
  };

  WrappedComponent.displayName = `withTailwindWrapper(${Component.displayName || Component.name})`;

  // Preserve all static properties from the original component
  // Use Object.assign to copy all enumerable properties
  Object.assign(WrappedComponent, Component);

  return WrappedComponent;
};
